export default function isActiveLink(link, activePath) {
  return link === activePath && activePath != null;
}